import { ApiValidationError } from '~~/errors/ApiValidationError'

/**
 * Extrait un message d'erreur lisible pour l'utilisateur à partir de toute erreur levée.
 * À utiliser dans les catch des formulaires pour afficher toujours un message clair.
 */
export function getErrorMessage(e: unknown): string {
  if (e instanceof ApiValidationError) {
    const parts = [e.message]
    if (e.fieldErrors && Object.keys(e.fieldErrors).length > 0) {
      const details = Object.entries(e.fieldErrors)
        .map(([, messages]) => messages.join(', '))
        .filter(Boolean)
      if (details.length > 0) parts.push(details.join(' - '))
    }
    return parts.join(' ')
  }
  if (e instanceof Error && e.message) return e.message
  if (e && typeof e === 'object' && 'message' in e && typeof (e as { message: unknown }).message === 'string') {
    return (e as { message: string }).message
  }
  return 'Une erreur inattendue s’est produite. Réessayez.'
}

/**
 * Normalise une chaîne pour les formulaires : trim, pas de null/undefined.
 */
export function normalizeString(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : ''
}
